import React, { useContext, useEffect } from 'react';
import { Navigate, Outlet, useParams } from 'react-router-dom';
import { ErpContext } from '../../context/ErpContext.js';
import { erpCookies } from '../../utils/erpCookies.js';

const PrivateRoute = ({ allowedRoles }) => {
  const { user, setIsSessionExpired } = useContext(ErpContext);
  const { tenant } = useParams();
  const loginPath = `/${tenant || erpCookies.get("tenantURL") || "default"}/login`;

  // 🔒 Validar cookie de seguridad al acceder a rutas protegidas
  useEffect(() => {
    const tenantCookie = erpCookies.get("tenant");
    
    // Si hay usuario pero no hay cookie de seguridad = sesión expirada
    if (user && !tenantCookie) {
      console.warn("⚠️ [PrivateRoute] Cookie tenant no existe, sesión expirada");
      setIsSessionExpired(true);
    }
  }, [user, setIsSessionExpired]);

  // Si no hay usuario, redirige al login DEL TENANT DE LA URL (no el de la cookie persistente)
  if (!user) {
    return <Navigate to={loginPath} replace />;
  }

  const liveTenant = erpCookies.get("tenant");
  if (tenant && liveTenant && String(liveTenant) !== String(tenant)) {
    return <Navigate to={loginPath} replace />;
  }

  // Si se especifican roles permitidos y el rol del usuario no coincide, muestra un mensaje de error o redirige
  if (allowedRoles && !allowedRoles.includes(user.rol)) {
    return <div>No tienes permiso para acceder a esta página.</div>;
  }

  // Si el usuario está autenticado y tiene permiso, renderiza las rutas internas (Outlet)
  return <Outlet />;
};

export default PrivateRoute;
